import { Core } from './Core';
import { contains, convert, remove, snakeToCamelCase } from 'utils/string';

interface Configurable {
	config: any;
}

export class FrameworkHelper {
	//Fairly cpu itensive
	public getParsedAttributes(element: Element): any {
		var attr = Core.DOM.getAttributes(element);

		for (var i in attr) {
			attr[i] = convert(attr[i]);
		}

		return attr;
	}

	public attributesToConfig(instance: Configurable, attributes: any, match = null): void {
		let name: string;
		let i: string;
		let matches: boolean;
		let clean: string;

		for (i in attributes) {
			matches = true;
			if (match && !contains(i, match)) {
				matches = false;
			}

			if (matches) {
				clean = remove(i, match + '-');
				name = snakeToCamelCase(clean);
				if (!instance.config) instance.config = {};
				instance.config[name] = attributes[i];
			}
		}
	}
}
